'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createContainer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _trie = require('./concerns/trie');

var _trie2 = _interopRequireDefault(_trie);

var _path_diff = require('./concerns/path_diff');

var _path_diff2 = _interopRequireDefault(_path_diff);

var _fiber = require('./concerns/fiber');

var _hot_zone_context = require('./hot_zone_context');

var _hot_zone_context2 = _interopRequireDefault(_hot_zone_context);

var _display_name = require('./display_name');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var rootDebug = (0, _debug2.default)('modula-react:root');

/*
# Rule 1 Use More General Self

If in the list there's a component which
  - is the same component
  - its pathDepth < current component's pathDepth

remove current component from the list


# Rule 2 Use More Specific Ancestor

If in the list there's a component which
  - is an ancestor of current component, and
  - its pathDepth >= current component's pathDepth

remove current component from the list


# Rule 3 Use More Specific Descendant

If in the list there's a component which
  - is a descendant of current component, and
  - its pathDepth > current component's pathDepth

remove current component from the list
*/
// this detection utilize _reactInternalFiber
// which is only available for react v16+
// support for older version is not considered
function safelyRemoveUnnecessaryUpdatesFor(impactedComponents) {
  var rule1 = function rule1(_ref) {
    var currentComponentPath = _ref.path,
        currentComponent = _ref.value;
    return (0, _ramda.find)(function (_ref2) {
      var path = _ref2.path,
          component = _ref2.value;
      return (0, _ramda.length)(path) < (0, _ramda.length)(currentComponentPath) && (0, _ramda.identical)(component, currentComponent);
    })(impactedComponents);
  };

  var rule2 = function rule2(_ref3) {
    var currentComponentPath = _ref3.path,
        currentComponent = _ref3.value;
    return (0, _ramda.find)(function (_ref4) {
      var path = _ref4.path,
          component = _ref4.value;
      return (0, _ramda.length)(path) >= (0, _ramda.length)(currentComponentPath) && (0, _fiber.isAncestor)(component._reactInternalFiber, currentComponent._reactInternalFiber);
    })(impactedComponents);
  };

  var rule3 = function rule3(_ref5) {
    var currentComponentPath = _ref5.path,
        currentComponent = _ref5.value;
    return (0, _ramda.find)(function (_ref6) {
      var path = _ref6.path,
          component = _ref6.value;
      return (0, _ramda.length)(path) > (0, _ramda.length)(currentComponentPath) && (0, _fiber.isDesendant)(component._reactInternalFiber, currentComponent._reactInternalFiber);
    })(impactedComponents);
  };

  return (0, _ramda.reject)((0, _ramda.anyPass)([rule1, rule2, rule3]), impactedComponents);
}

var LeanRenderer = function () {
  function LeanRenderer() {
    _classCallCheck(this, LeanRenderer);

    this.hotZones = new _trie2.default();
  }

  _createClass(LeanRenderer, [{
    key: 'registerZone',
    value: function registerZone(path, component) {
      this.hotZones.add(path, component);
      rootDebug('registered', path, (0, _display_name.getDisplayName)(component), this.hotZones);
    }
  }, {
    key: 'unregisterZone',
    value: function unregisterZone(path, component) {
      this.hotZones.remove(path, component);
      rootDebug('unregistered', path, (0, _display_name.getDisplayName)(component), this.hotZones);
    }

    // safty first

  }, {
    key: 'updateZones',
    value: function updateZones(oldRoot, newRoot) {
      var _pathDiff = (0, _path_diff2.default)([], oldRoot, newRoot),
          updatedPaths = _pathDiff.updatedPaths,
          deletedPaths = _pathDiff.deletedPaths,
          createdPaths = _pathDiff.createdPaths;

      var impactedPaths = (0, _ramda.uniq)((0, _ramda.concat)(updatedPaths,
      // changes like deletion and creation should propagate to its parent
      // themselves are unable to handle the changes
      (0, _ramda.concat)((0, _ramda.map)((0, _ramda.dropLast)(1), deletedPaths), (0, _ramda.map)((0, _ramda.dropLast)(1), createdPaths))));

      rootDebug('impacted paths: ', impactedPaths);

      // find all components that are registered on impacted paths
      var impactedComponents = (0, _ramda.uniq)((0, _ramda.flatten)((0, _ramda.map)(this.hotZones.valuesInPath.bind(this.hotZones), impactedPaths)));

      rootDebug('impacted components: ', impactedComponents);

      var responsibleComponents = safelyRemoveUnnecessaryUpdatesFor(impactedComponents);

      rootDebug('responsible components: ', responsibleComponents);

      (0, _ramda.forEach)(function (component) {
        rootDebug('triggering render: ', component);
        component.forceUpdate();
      }, (0, _ramda.map)((0, _ramda.prop)('value'), responsibleComponents));
    }
  }]);

  return LeanRenderer;
}();

function createContainer(store, DecoratedComponent) {
  var lastModel = store.getState();
  var renderer = new LeanRenderer();

  function handleUpdate() {
    var newModel = store.getState();

    if (newModel !== lastModel) {
      var oldModel = lastModel;
      // since rendering can be much slower
      // "commit" first then trigger rendering
      // to avoid possible race condition
      // maybe we can queue rendering request here
      // to avoid some "renderings in the middle"
      lastModel = newModel;
      renderer.updateZones(oldModel, newModel);
    }
  }

  return function (_Component) {
    _inherits(RootComponent, _Component);

    function RootComponent() {
      _classCallCheck(this, RootComponent);

      return _possibleConstructorReturn(this, (RootComponent.__proto__ || Object.getPrototypeOf(RootComponent)).apply(this, arguments));
    }

    _createClass(RootComponent, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.unsubscribe = store.subscribe(handleUpdate);
        renderer.registerZone([], this);
        store.getState().sendInit();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.unsubscribe();
        renderer.unregisterZone([], this);
        store.getState().sendDestroy();
      }
    }, {
      key: 'render',
      value: function render() {
        var rootModel = store.getState();

        if (rootModel && rootModel.get('decoratedModel')) {
          return _react2.default.createElement(
            _hot_zone_context2.default.Provider,
            {
              value: {
                getStateInPath: function getStateInPath(path) {
                  return store.getState().getIn(path);
                },
                registerZone: renderer.registerZone.bind(renderer),
                unregisterZone: renderer.unregisterZone.bind(renderer)
              }
            },
            _react2.default.createElement(DecoratedComponent, { model: rootModel.get('decoratedModel') })
          );
        } else {
          return _react2.default.createElement('noscript', null);
        }
      }
    }]);

    return RootComponent;
  }(_react.Component);
}